import { Component, Input } from '@angular/core';
import { ImageMetadata } from 'app/shared/models/image-metadata.model';

@Component({
  selector: 'ez-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input({ required: true }) assetBucketUrl: string;
  @Input({ required: true }) imageData: ImageMetadata;
  @Input({ required: true }) organisationName: string;
}
